import React, { useRef } from 'react';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { ListBoxItemClickEvent } from '@progress/kendo-react-listbox';
import cn from 'clsx';
import { SearchBox } from '../../search-box';
import styles from '../style.module.scss';
import DragDropCardTitle from '@components-clean/core/drag-drop-lists-core/drag-drop-card-title';
import {
    DefaultDragDropItem,
    DRAG_DROP_FILTER_HEIGHT,
    DRAG_DROP_SELECTED_FIELD,
} from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.helper';
import { SingleDragDropListProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import ListBox from '@components-clean/core/drag-drop-lists-core/listbox';
import Card from 'views-clean/components/core/card';

const SingleDragDropList = ({
    columnsState,
    handleDragStart,
    handleDrop,
    handleItemClick,
    filter,
    setFilter,
    listHeader,
    renderItemLeft,
    className,
    disabled,
}: SingleDragDropListProps) => {
    const filterRef = useRef<HTMLDivElement>(null);

    return (
        <div data-testid="drag-drop-lists" className={cn(className, styles.alignedListboxes)}>
            <Card
                title={
                    <DragDropCardTitle
                        title={listHeader}
                        numberOfRecords={columnsState.rightColumn.filter((item) => item.filtered).length}
                    />
                }
                className="k-h-full"
                padding="none"
                data-testid="left-listbox"
            >
                <>
                    <div ref={filterRef} style={{ position: 'relative' }}>
                        <SearchBox
                            fillMode="flat"
                            data-testid="search-item-input"
                            showSearchIcon
                            value={filter}
                            onChange={(e: TextBoxChangeEvent) => setFilter((e.value as string) ?? '')}
                        />
                    </div>
                    <div
                        data-testid="drag-drop-left-list"
                        style={{
                            height: `calc(100% - ${filterRef.current?.clientHeight ?? DRAG_DROP_FILTER_HEIGHT}px)`,
                        }}
                    >
                        <ListBox
                            className="w-full !k-h-full"
                            textField="text"
                            data={columnsState.rightColumn.filter((item) => item.filtered)}
                            selectedField={DRAG_DROP_SELECTED_FIELD}
                            onItemClick={(e: ListBoxItemClickEvent) => handleItemClick(e, 'leftColumn', 'rightColumn')}
                            onDragStart={handleDragStart}
                            onDrop={handleDrop}
                            item={renderItemLeft ?? DefaultDragDropItem}
                            draggable={!disabled}
                        />
                    </div>
                </>
            </Card>
        </div>
    );
};

export default SingleDragDropList;
